import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-righttextbutton',
  templateUrl: './righttextbutton.component.html',
  standalone: true,
})
export class RightTextButton {
  @Input() linktext: string = '';
  @Output() linkclick = new EventEmitter<void>();
  linkedClicked() {
    this.linkclick.emit();
  }
}
